<label>
  <input type="checkbox" [checked]="checked" />
  <i></i>
</label>
